let vibe_cake_masters_header_account_menu = function( $ ) {

	let $menu,
		anim_speed = 400;

	let _init = function() {
		$menu = $( '#masters-header-account-menu' );

		if ( $menu.length > 0 ) {
			_setup_toggle();
		}
	};

	let _setup_toggle = function() {
		$menu.find( 'a.toggle-dropdown-panel' ).on( 'click', ( e ) => {
			e.preventDefault();

			_toggle();
		} );
	};

	let _toggle = function() {
		if ( $menu.hasClass( 'animating' ) ) {
			return;
		}

		$menu.addClass( 'animating' );

		if ( $menu.hasClass( 'open' ) ) {
			_close();
		} else {
			_open();
		}

		setTimeout( () => {
			$menu.removeClass( 'animating' );
		}, anim_speed );
	};

	let _open = function() {
		$menu.removeClass( 'closed' );
		$menu.addClass( 'open' );
		$menu.find( '.dropdown-panel' ).slideDown( anim_speed );
	};

	let _close = function() {
		$menu.removeClass( 'open' );
		$menu.addClass( 'closed' );
		$menu.find( '.dropdown-panel' ).slideUp( anim_speed );
	};

	$( document ).ready( _init );

} ( jQuery );

module.exports = vibe_cake_masters_header_account_menu;